// @flow

import $ from 'jquery'

export const updateCards = () => {
  const $cards = $('[data-card]')
  const selectedGrade = $('.active[data-button="select-grade"]').attr('data-grade')
  const selectedType = $('.active[data-button="select-type"]').attr('data-type')

  $cards.removeClass('active')

  $cards.each((_i, item) => {
    const $item = $(item)
    const grade = $item.attr('data-grade')
    const type = $item.attr('data-type')

    if (grade.includes(selectedGrade) && type === selectedType) {
      $item.addClass('active')
    }
  })
}
